import axios from "axios";

const lang = localStorage.getItem("lang") || "cn";

const roleMap =
    lang === "en"
        ? {
            DEFAULT: "Visitor",
        }
        : {
            DEFAULT: "访客"
        };


export const getProfile = async () => {
    const res = await axios.get("/user/me");
    const data = res.data;

    let designationLabel = roleMap["DEFAULT"];

    if (data.designation) {
        const position = JSON.parse(data.designation);
        designationLabel = lang === "en" ? position.en : position.cn || roleMap["DEFAULT"];
    }

    return {
        ...data,
        designationLabel
    };
};

export const login = async (email, pwd) => {
    const res = await axios.post("/user/login", { email, pwd });
    const data = res.data;

    let designationLabel = roleMap["DEFAULT"];

    if (data.designation) {
        const position = JSON.parse(data.designation);
        designationLabel = lang === "en" ? position.en : position.cn || roleMap["DEFAULT"];
    }

    return {
        ...data,
        designationLabel
    };
};

export const logout = async () => {
    await axios.post("user/logout");
};

export const getCompanies = async () => {
    console.log("Company API Called!")
    const res = await axios.get("/products/pn/companies");
    return res.data
}

export const getCategoriesByCompanyCode = async (companyCode) => {
    console.log("Category API Called!")
    const res = await axios.get(`/products/pn/categories?company=${companyCode}`);
    return res.data
}

export const addCategory = async ({categoryName, categoryChineseName, categoryCode, entryOperator, companyCode}) => {
    console.log("Sub Category API Called!")
    const res = await axios.post("/products/pn/categories/add", {
        categoryName,
        categoryChineseName,
        categoryCode,
        entryOperator,
        company: {
            companyCode
        }
    });
    return res.data
}

export const getSubCategories = async (categoryCode, companyCode) => {
    console.log("Getting Subcategories", categoryCode, companyCode);
    const res = await axios.get(`/products/pn/sub-categories?category=${categoryCode}&company=${companyCode}`);
    return res.data;
}

export const addSubCategory = async ({subCategoryName, subCategoryChineseName, subCategoryCode, entryOperator, categoryCode, companyCode}) => {
    console.log(subCategoryName, subCategoryCode, entryOperator, categoryCode);
    const res = await axios.post("/products/pn/sub-categories/add", {
        subCategoryName,
        subCategoryChineseName,
        subCategoryCode,
        entryOperator,
        category: {
            categoryCode
        },
        companyCode
    });
    return res.data;
}

export const generateProductPN = async (formData) => {
    try {
        const res = await axios.post("/products/add", formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        });

        console.log("✅ Response:", res.data); // 🔹 log success
        return res.data;
    } catch (err) {
        if (err.response) {
            console.error("❌ Error response:", err.response); // 🔹 log full response
        } else {
            console.error("❌ Error:", err);
        }
        throw err; // re-throw so caller can handle
    }
};

export const updateProduct = async (formData) => {
    try{
        const res = await axios.put("/products/update", formData);

        console.log("✅ Update Product Response:", res.data);
        return res.data;
    }catch (err){
        if (err.response) {
            console.error("❌ Error response:", err.response);
        } else {
            console.error("❌ Error:", err);
        }
        throw err;
    }
}

// Delete Product by PN
export const deleteProductByPn = async (pn) => {
    try {
        const res = await axios.delete(`/products?pn=${pn}`);
        console.log("✅ Delete Product Response:", res.data);
        return res.data; // could be { success: true } or message
    } catch (err) {
        if (err.response) {
            console.error("❌ Error response:", err.response);
        } else {
            console.error("❌ Error:", err);
        }
        throw err;
    }
};


export const getAllProductPNs = async (page,size) => {
    const res = await axios.get(`/products/all?page=${page}&size=${size}`);
    console.log(res.data);
    return res.data;
}

export const searchProductPNs = async (query, page, size) => {
    const res = await axios.get(`/products/search?query=${query}&page=${page}&size=${size}`);
    return res.data;
}

export const DownloadProductPNExcel = async (searchQuery) => {
    const res = await axios.get("/products/download", {
        params:{keyword: searchQuery},
        responseType: "blob",
    });

    console.log(res.headers)

    // Get filename from Content-Disposition header
    let filename = "product_pn.xlsx"; // fallback
    const disposition = res.headers["content-disposition"];
    if (disposition && disposition.includes("filename=")) {
        filename = disposition
            .split("filename=")[1]
            .replace(/"/g, ""); // remove quotes if any
    }

    // Create download
    const blob = new Blob(
        [res.data],
        {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        }
    );

    const url = window.URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();

    // Cleanup
    a.remove();
    window.URL.revokeObjectURL(url);
};


// Admin Apis
//Get All Users
export const getAllUsers = async () => {
    console.log("Users API Called!");
    const res = await axios.get("/user/all");
    return res.data;
};

export const getMyProfileDetails = async () => {
    const res = await axios.get("/user/me");
    return res.data;
};

export const getMyRecentActivities = async () => {
    const res = await axios.get("/user/me/activities");
    return res.data;
};

export const getOrganizationOptions = async () => {
    const res = await axios.get("/user/organization/options");
    return res.data;
};

export const getOrganizationTree = async () => {
    const res = await axios.get("/user/organization");
    return res.data;
};

export const getUserDetails = async (id) => {
    const res = await axios.get(`/user/admin/${id}`);
    return res.data;
}

export const getAdminUserTasks = async (id, year, month) => {
    const res = await axios.get(`/tasks/admin/user/${id}?year=${year}&month=${month}`);
    return res.data;
};

export const getAdminUserActivities = async (id, page = 0, size = 10) => {
    const res = await axios.get(`/user/admin/${id}/activities?page=${page}&size=${size}`);
    return res.data;
};

export const getAllServices = async() => {
    const res = await axios.get('/user/admin/services');
    return res.data;
}

export const getDefaultPublicUserImage = async() => {
    const res = await axios.get('/user/admin/default-image');
    return res.data;
}

export const updateUserByAdmin = async(id, body) =>{
    const res = await axios.put(`/user/admin/${id}`, body);
    return res.data;
}

export const addUser = async(body) => {
    const res = await axios.post(`/user/admin`, body);
    return res.data;
}

export const deleteUser = async(userId) => {
    const res = await axios.delete(`/user/admin/${userId}`);
    return res.data;
}

export const getAllUserActivities = async(page, size) => {
    const res = await axios.get(`/user/admin/activities?page=${page}&size=${size}`);
    return res.data;
}

export const searchUserActivities = async (query, page, size) => {
    const res = await axios.get(`/user/admin/activities/search?query=${query}&page=${page}&size=${size}`);
    return res.data;
}
export const getProduct = async(pn) => {
    const res = await axios.get(`/products?pn=${pn}`);
    return res.data;
}

export const getTrafficData = async (days) => {
    const res = await axios.get(`/google/api/analytics?days=${days}`);
    return res.data;
};

export const getDashboardData = async () => {
    const res = await axios.get('/user/dashboard/data');
    return res.data;
}

export const getHomeData = async () => {
    const res = await axios.get('/user/home/data');
    return res.data;
}

export const getChatroomsByTab = async (tab = "waiting") => {
    const res = await axios.get(`/chatrooms?tab=${encodeURIComponent(tab)}`);
    return res.data;
}

export const getChatroomSummary = async () => {
    const res = await axios.get('/chatrooms/summary');
    return res.data;
}

export const searchChatrooms = async (query = "") => {
    const res = await axios.get(`/chatrooms/search?query=${encodeURIComponent(query)}`);
    return res.data;
};

export const getChatroomMessages = async (chatroomId, params = {}) => {
    const query = new URLSearchParams();
    if (params.sessionId) query.append("sessionId", params.sessionId);
    if (params.beforeId) query.append("beforeId", params.beforeId);
    query.append("limit", params.limit || 20);
    const res = await axios.get(`/chatrooms/${chatroomId}/messages?${query.toString()}`);
    return res.data;
};

export const sendChatroomMessage = async (chatroomId, payload) => {
    const body = typeof payload === "string" ? {messageText: payload} : payload;
    const query = body?.sessionId ? `?sessionId=${encodeURIComponent(body.sessionId)}` : "";
    const res = await axios.post(`/chatrooms/${chatroomId}/messages${query}`, body);
    return res.data;
};

export const uploadChatroomFile = async (chatroomId, file, senderParticipantId = "", sessionId = "") => {
    const formData = new FormData();
    if (senderParticipantId) formData.append("senderParticipantId", senderParticipantId);
    formData.append("file", file);
    const query = sessionId ? `?sessionId=${encodeURIComponent(sessionId)}` : "";
    const res = await axios.post(`/chatrooms/${chatroomId}/upload${query}`, formData, {
        headers: { "Content-Type": "multipart/form-data" }
    });
    return res.data;
};

export const deleteChatroomMessage = async (chatroomId, messageId) => {
    const res = await axios.delete(`/chatrooms/${chatroomId}/messages/${messageId}`);
    return res.data;
};

export const deleteChatroom = async (chatroomId) => {
    const res = await axios.delete(`/chatrooms/${chatroomId}`);
    return res.data;
};

export const updateChatroomVisitorTag = async (chatroomId, visitorTag) => {
    const res = await axios.patch(`/chatrooms/${chatroomId}/tag`, { visitorTag });
    return res.data;
};

export const updateChatroomVisitor = async (chatroomId, visitor) => {
    const res = await axios.post(`/chatrooms/${chatroomId}/visitor`, visitor);
    return res.data;
};

export const updateChatroomTyping = async (chatroomId, typing, details = {}) => {
    const query = details.sessionId ? `?sessionId=${encodeURIComponent(details.sessionId)}` : "";
    const res = await axios.post(`/chatrooms/${chatroomId}/typing${query}`, { typing, ...details });
    return res.data;
};

export const requestVisitorLoadMessages = async (chatroomId, details = {}) => {
    const query = details.sessionId ? `?sessionId=${encodeURIComponent(details.sessionId)}` : "";
    const res = await axios.post(`/chatrooms/${chatroomId}/requests/load-messages${query}`, details);
    return res.data;
};

export const getChatroomTyping = async (chatroomId, sessionId = "") => {
    const query = sessionId ? `?sessionId=${encodeURIComponent(sessionId)}` : "";
    const res = await axios.get(`/chatrooms/${chatroomId}/typing${query}`);
    return res.data;
};

export const enterChatroom = async (chatroomId) => {
    const res = await axios.patch(`/chatrooms/${chatroomId}/enter`);
    return res.data;
};

export const leaveChatroom = async (chatroomId) => {
    const res = await axios.patch(`/chatrooms/${chatroomId}/leave`);
    return res.data;
};

export const getChatroomSessions = async (chatroomId) => {
    const res = await axios.get(`/chatrooms/${chatroomId}/sessions`);
    return res.data;
};

export const startChatroomSession = async (chatroomId) => {
    const res = await axios.post(`/chatrooms/${chatroomId}/sessions`);
    return res.data;
};

export const endChatroomSession = async (chatroomId, sessionId) => {
    const res = await axios.patch(`/chatrooms/${chatroomId}/sessions/${sessionId}/end`);
    return res.data;
};

export const getFormSubmissions = async (type, params = {}) => {
    const query = new URLSearchParams();
    query.set("websiteCode", params.websiteCode || "xsg");
    query.set("status", params.status || "all");
    query.set("limit", params.limit || 50);
    const res = await axios.get(`/forms/${type}?${query.toString()}`);
    return res.data;
};

export const updateFormSubmissionStatus = async (type, id, status) => {
    const res = await axios.patch(`/forms/${type}/${id}/status`, {status});
    return res.data;
};

// Task APIs
export const getMyTasks = async (year, month, projectId) => {
    const params = new URLSearchParams();
    if (year) params.append("year", year);
    if (month) params.append("month", month);
    if (projectId) params.append("projectId", projectId);
    const query = params.toString();
    const res = await axios.get(`/tasks/my${query ? `?${query}` : ""}`);
    return res.data;
};

export const getTasks = async () => {
    const res = await axios.get("/tasks");
    return res.data;
};

export const getTaskAssignees = async () => {
    const res = await axios.get("/tasks/assignees");
    return res.data;
};

export const getTaskById = async (id) => {
    const res = await axios.get(`/tasks/${id}`);
    return res.data;
};

export const createTask = async (taskData, attachments, inlineImages) => {
    const formData = new FormData();
    formData.append("task", new Blob([JSON.stringify(taskData)], { type: "application/json" }));
    if (attachments && attachments.length > 0) {
        attachments.forEach(f => formData.append("attachments", f));
    }
    if (inlineImages && inlineImages.length > 0) {
        inlineImages.forEach(f => formData.append("inlineImages", f));
    }
    const res = await axios.post("/tasks", formData, { headers: { "Content-Type": "multipart/form-data" } });
    return res.data;
};

export const createTaskOnly = async (taskData, attachments, inlineImages) => {
    const formData = new FormData();
    formData.append("task", new Blob([JSON.stringify(taskData)], { type: "application/json" }));
    if (attachments && attachments.length > 0) {
        attachments.forEach(f => formData.append("attachments", f));
    }
    if (inlineImages && inlineImages.length > 0) {
        inlineImages.forEach(f => formData.append("inlineImages", f));
    }
    const res = await axios.post("/tasks/create", formData, { headers: { "Content-Type": "multipart/form-data" } });
    return res.data;
};

export const assignExistingTask = async (id, taskData, assignmentInlineImages) => {
    const formData = new FormData();
    formData.append("task", new Blob([JSON.stringify(taskData)], { type: "application/json" }));
    if (assignmentInlineImages && assignmentInlineImages.length > 0) {
        assignmentInlineImages.forEach(f => formData.append("assignmentInlineImages", f));
    }
    const res = await axios.post(`/tasks/${id}/assign`, formData, { headers: { "Content-Type": "multipart/form-data" } });
    return res.data;
};

export const updateTask = async (id, taskData, attachments, inlineImages, assignmentInlineImages) => {
    const formData = new FormData();
    formData.append("task", new Blob([JSON.stringify(taskData)], { type: "application/json" }));
    if (attachments && attachments.length > 0) {
        attachments.forEach(f => formData.append("attachments", f));
    }
    if (inlineImages && inlineImages.length > 0) {
        inlineImages.forEach(f => formData.append("inlineImages", f));
    }
    if (assignmentInlineImages && assignmentInlineImages.length > 0) {
        assignmentInlineImages.forEach(f => formData.append("assignmentInlineImages", f));
    }
    const res = await axios.put(`/tasks/${id}`, formData, { headers: { "Content-Type": "multipart/form-data" } });
    return res.data;
};

export const updateTaskStatus = async (id, taskStatus, assignmentId) => {
    const params = new URLSearchParams({ taskStatus });
    if (assignmentId) params.set("assignmentId", assignmentId);
    const res = await axios.put(`/tasks/${id}/status?${params.toString()}`);
    return res.data;
};

export const deleteTask = async (id) => {
    const res = await axios.delete(`/tasks/${id}`);
    return res.data;
};

export const deleteTaskAssignment = async (taskId, assignmentId) => {
    const res = await axios.delete(`/tasks/${taskId}/assignments/${assignmentId}`);
    return res.data;
};

export const getTaskSubmissions = async (taskId) => {
    const res = await axios.get(`/tasks/${taskId}/submissions`);
    return res.data;
};

export const createTaskSubmission = async (taskId, payload, inlineImages, attachments) => {
    const formData = new FormData();
    formData.append("submission", new Blob([JSON.stringify(payload)], { type: "application/json" }));
    if (inlineImages && inlineImages.length > 0) {
        inlineImages.forEach(f => formData.append("inlineImages", f));
    }
    if (attachments && attachments.length > 0) {
        attachments.forEach(f => formData.append("attachments", f));
    }
    const res = await axios.post(`/tasks/${taskId}/submissions`, formData, {
        headers: { "Content-Type": "multipart/form-data" }
    });
    return res.data;
};

export const approveTaskSubmission = async (taskId, submissionId, feedback = "", inlineImages, attachments) => {
    const formData = new FormData();
    formData.append("review", new Blob([JSON.stringify({ reviewRemarks: feedback })], { type: "application/json" }));
    if (inlineImages && inlineImages.length > 0) {
        inlineImages.forEach(f => formData.append("inlineImages", f));
    }
    if (attachments && attachments.length > 0) {
        attachments.forEach(f => formData.append("attachments", f));
    }
    const res = await axios.put(`/tasks/${taskId}/submissions/${submissionId}/approve`, formData, {
        headers: { "Content-Type": "multipart/form-data" }
    });
    return res.data;
};

export const rejectTaskSubmission = async (taskId, submissionId, feedback, inlineImages, attachments) => {
    const formData = new FormData();
    formData.append("review", new Blob([JSON.stringify({ reviewRemarks: feedback })], { type: "application/json" }));
    if (inlineImages && inlineImages.length > 0) {
        inlineImages.forEach(f => formData.append("inlineImages", f));
    }
    if (attachments && attachments.length > 0) {
        attachments.forEach(f => formData.append("attachments", f));
    }
    const res = await axios.put(`/tasks/${taskId}/submissions/${submissionId}/reject`, formData, {
        headers: { "Content-Type": "multipart/form-data" }
    });
    return res.data;
};

export const getTaskProjects = async () => {
    const res = await axios.get("/tasks/projects");
    return res.data;
};

export const createTaskProject = async (project) => {
    const res = await axios.post("/tasks/projects", project);
    return res.data;
};

export const getComments = async (commentType, targetId) => {
    const params = new URLSearchParams({ commentType, targetId: String(targetId) });
    const res = await axios.get(`/comments?${params.toString()}`);
    return res.data;
};

export const addComment = async (payload) => {
    const res = await axios.post("/comments", payload);
    return res.data;
};

export const updateComment = async (commentId, payload) => {
    const res = await axios.put(`/comments/${commentId}`, payload);
    return res.data;
};

export const deleteComment = async (commentId) => {
    const res = await axios.delete(`/comments/${commentId}`);
    return res.data;
};

//Mfg Product Manufacturing
export const getMfgProductFamilies = async () => {
    const res = await axios.get('/products/mfg/product-families')
    return res.data;
}
export const getOpenTypeProductCategories = async (familyId) => {
    const res = await axios.get(`/products/mfg/product-titles?familyId=${familyId}`)
    return res.data;
}
export const getMfgCategoriesByProductFamilyId = async (familyId) => {
    const res = await axios.get(`/products/mfg/categories/${familyId}`);
    return res.data;
}

export const getMfgSubCategoriesByCategoryIdAndProductFamilyId =async (categoryId, familyId) => {
    const res = await axios.get(`/products/mfg/subcategories?categoryId=${categoryId}&productFamilyId=${familyId}`);
    return res.data;
}

export const createMfgProduct = async (payload, images, attachments) => {
    try {
        const formData = new FormData(); // ✅ FIXED

        formData.append(
            "product",
            new Blob([JSON.stringify(payload)], { type: "application/json" })
        );

        // images
        if (images && images.length > 0) {
            images.forEach(img => formData.append("images", img));
        }

        // attachments
        if (attachments && attachments.length > 0) {
            attachments.forEach(file => formData.append("attachments", file));
        }

        const res = await axios.post("/products/mfg/add", formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        });

        return res.data;

    } catch (err) {
        console.error("❌ API Error:", err);
        throw err;
    }
};

export const addOpenTypeCategory = async (categoryTitleId, payload) => {
    try {
        const response = await axios.post(
            `/products/mfg/open-type/categories/add/${categoryTitleId}`,
            payload
        );

        return response.data;
    } catch (error) {
        console.error("Add category error:", error);
        throw error;
    }
};

export const addClosedTypeCategory = (productFamilyId, payload) => {
    return axios
        .post(`/products/mfg/closed-type/category/add/${productFamilyId}`, payload)
        .then(res => res.data);
};

export const addClosedTypeSubCategory = (categoryId, payload) => {
    return axios
        .post(`/products/mfg/closed-type/subcategory/add/${categoryId}`, payload)
        .then(res => res.data);
};
export const getAllMfgProductPNs = async (page,size) => {
    const res = await axios.get(`/products/mfg/all?page=${page}&size=${size}`);
    console.log(res.data);
    return res.data;
}
export const searchMfgProductPNs = async (query, page, size) => {
    const res = await axios.get(`/products/mfg/search?query=${query}&page=${page}&size=${size}`);
    return res.data;
}

export const DownloadMfgProductPNExcel = async (searchQuery) => {
    const res = await axios.get("/products/mfg/download", {
        params:{keyword: searchQuery},
        responseType: "blob",
    });

    console.log(res.headers)

    // Get filename from Content-Disposition header
    let filename = "mfg_product_pn.xlsx"; // fallback
    const disposition = res.headers["content-disposition"];
    if (disposition && disposition.includes("filename=")) {
        filename = disposition
            .split("filename=")[1]
            .replace(/"/g, ""); // remove quotes if any
    }

    // Create download
    const blob = new Blob(
        [res.data],
        {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        }
    );

    const url = window.URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();

    // Cleanup
    a.remove();
    window.URL.revokeObjectURL(url);
};

export const getMfgProduct = async(pn) => {
    const res = await axios.get(`/products/mfg?pn=${pn}`);
    return res.data;
}

export const deleteMfgProductByPn = async (pn) => {
    try {
        const res = await axios.delete(`/products/mfg?pn=${pn}`);
        console.log("✅ Delete Product Response:", res.data);
        return res.data;
    } catch (err) {
        if (err.response) {
            console.error("❌ Error response:", err.response);
        } else {
            console.error("❌ Error:", err);
        }
        throw err;
    }
};

export const updateMfgProduct = async (formData) => {
    try{
        const res = await axios.put("/products/mfg/update", formData);

        console.log("✅ Update Product Response:", res.data);
        return res.data;
    }catch (err){
        if (err.response) {
            console.error("❌ Error response:", err.response);
        } else {
            console.error("❌ Error:", err);
        }
        throw err;
    }
}


// ===================== CDP - Customer Development =====================

// Companies
export const getCdpCompanies = async (page = 0, size = 20, companyClassification = "") => {
    const classificationQuery = companyClassification ? `&companyClassification=${encodeURIComponent(companyClassification)}` : "";
    const res = await axios.get(`/cdp/companies?page=${page}&size=${size}${classificationQuery}`);
    return res.data;
};

export const searchCdpCompanies = async (query, page = 0, size = 20, companyClassification = "") => {
    const classificationQuery = companyClassification ? `&companyClassification=${encodeURIComponent(companyClassification)}` : "";
    const res = await axios.get(`/cdp/companies/search?query=${encodeURIComponent(query)}&page=${page}&size=${size}${classificationQuery}`);
    return res.data;
};

export const getCdpCompanyById = async (id) => {
    const res = await axios.get(`/cdp/companies/${id}`);
    return res.data;
};

export const getCdpCountryOptions = async (query = "") => {
    const q = query?.trim();
    const res = await axios.get(q ? `/cdp/countries?query=${encodeURIComponent(q)}` : "/cdp/countries");
    return res.data;
};

export const createCdpCompany = async (companyData, logo, attachments) => {
    const formData = new FormData();
    formData.append("company", new Blob([JSON.stringify(companyData)], { type: "application/json" }));
    if (logo) formData.append("logo", logo);
    if (attachments && attachments.length > 0) {
        attachments.forEach(f => formData.append("attachments", f));
    }
    const res = await axios.post("/cdp/companies", formData, { headers: { "Content-Type": "multipart/form-data" } });
    return res.data;
};

export const updateCdpCompany = async (id, companyData, logo, attachments) => {
    const formData = new FormData();
    formData.append("company", new Blob([JSON.stringify(companyData)], { type: "application/json" }));
    if (logo) formData.append("logo", logo);
    if (attachments && attachments.length > 0) {
        attachments.forEach(f => formData.append("attachments", f));
    }
    const res = await axios.put(`/cdp/companies/${id}`, formData, { headers: { "Content-Type": "multipart/form-data" } });
    return res.data;
};

export const deleteCdpCompany = async (id) => {
    await axios.delete(`/cdp/companies/${id}`);
};

// Contacts
export const getCdpContactsByCompany = async (companyId) => {
    const res = await axios.get(`/cdp/companies/${companyId}/contacts`);
    return res.data;
};

export const getCdpContacts = async (page = 0, size = 20) => {
    const res = await axios.get(`/cdp/contacts?page=${page}&size=${size}`);
    return res.data;
};

export const getCdpContactById = async (id) => {
    const res = await axios.get(`/cdp/contacts/${id}`);
    return res.data;
};

export const createCdpContact = async (contactData, profilePicture) => {
    const formData = new FormData();
    formData.append("contact", new Blob([JSON.stringify(contactData)], { type: "application/json" }));
    if (profilePicture) formData.append("profilePicture", profilePicture);
    const res = await axios.post("/cdp/contacts", formData, { headers: { "Content-Type": "multipart/form-data" } });
    return res.data;
};

export const updateCdpContact = async (id, contactData, profilePicture) => {
    const formData = new FormData();
    formData.append("contact", new Blob([JSON.stringify(contactData)], { type: "application/json" }));
    if (profilePicture) formData.append("profilePicture", profilePicture);
    const res = await axios.put(`/cdp/contacts/${id}`, formData, { headers: { "Content-Type": "multipart/form-data" } });
    return res.data;
};

export const deleteCdpContact = async (id) => {
    await axios.delete(`/cdp/contacts/${id}`);
};

// Activities
export const getCdpActivitiesByContact = async (contactId) => {
    const res = await axios.get(`/cdp/contacts/${contactId}/activities`);
    return res.data;
};

export const getCdpActivitiesByCompany = async (companyId) => {
    const res = await axios.get(`/cdp/companies/${companyId}/activities`);
    return res.data;
};

export const createCdpActivity = async (activityData, attachments, inlineImages) => {
    const formData = new FormData();
    formData.append("activity", new Blob([JSON.stringify(activityData)], { type: "application/json" }));
    if (inlineImages && inlineImages.length > 0) {
        inlineImages.forEach(f => formData.append("inlineImages", f));
    }
    if (attachments && attachments.length > 0) {
        attachments.forEach(f => formData.append("attachments", f));
    }
    const res = await axios.post("/cdp/activities", formData, { headers: { "Content-Type": "multipart/form-data" } });
    return res.data;
};

export const updateCdpActivity = async (id, activityData, attachments, inlineImages) => {
    const formData = new FormData();
    formData.append("activity", new Blob([JSON.stringify(activityData)], { type: "application/json" }));
    if (inlineImages && inlineImages.length > 0) {
        inlineImages.forEach(f => formData.append("inlineImages", f));
    }
    if (attachments && attachments.length > 0) {
        attachments.forEach(f => formData.append("attachments", f));
    }
    const res = await axios.put(`/cdp/activities/${id}`, formData, { headers: { "Content-Type": "multipart/form-data" } });
    return res.data;
};

export const deleteCdpActivity = async (id) => {
    await axios.delete(`/cdp/activities/${id}`);
};

// Trade Data
export const getCdpTradeDataByCompany = async (companyId) => {
    const res = await axios.get(`/cdp/companies/${companyId}/trade-data`);
    return res.data;
};

export const createCdpTradeData = async (tradeData, attachments) => {
    const formData = new FormData();
    formData.append("tradeData", new Blob([JSON.stringify(tradeData)], { type: "application/json" }));
    if (attachments && attachments.length > 0) {
        attachments.forEach(f => formData.append("attachments", f));
    }
    const res = await axios.post("/cdp/trade-data", formData, { headers: { "Content-Type": "multipart/form-data" } });
    return res.data;
};

export const updateCdpTradeData = async (id, tradeData, attachments) => {
    const formData = new FormData();
    formData.append("tradeData", new Blob([JSON.stringify(tradeData)], { type: "application/json" }));
    if (attachments && attachments.length > 0) {
        attachments.forEach(f => formData.append("attachments", f));
    }
    const res = await axios.put(`/cdp/trade-data/${id}`, formData, { headers: { "Content-Type": "multipart/form-data" } });
    return res.data;
};

export const deleteCdpTradeData = async (id) => {
    await axios.delete(`/cdp/trade-data/${id}`);
};

// Sample Requests
export const getCdpSampleRequestsByCompany = async (companyId) => {
    const res = await axios.get(`/cdp/companies/${companyId}/samples`);
    return res.data;
};

export const createCdpSampleRequest = async (sampleData) => {
    const res = await axios.post("/cdp/samples", sampleData);
    return res.data;
};

export const updateCdpSampleRequest = async (id, sampleData) => {
    const res = await axios.put(`/cdp/samples/${id}`, sampleData);
    return res.data;
};

export const deleteCdpSampleRequest = async (id) => {
    await axios.delete(`/cdp/samples/${id}`);
};

// Close Chat rooms
export const closeChatroom = async (chatroomId) => {
    const res = await axios.patch(
        `/chatrooms/${chatroomId}/close`
    );
    return res.data;
};



